export default {
    cities: [],
    selectedCity: {},
    error: false,
    errorMessage: '',
}
